import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Segment } from 'component/Space/Segment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { SkinIndex } from 'type/Identity'
import css from './SkinColor.module.scss'

type Props = {
  skin: SkinIndex
}

function getClassName(skin: SkinIndex): string | undefined {
  if (skin === 1) return css.color1
  if (skin === 2) return css.color2
  if (skin === 3) return css.color3
  if (skin === 4) return css.color4
  if (skin === 5) return css.color5
}

export const SkinColor = observer(({ skin }: Props) => {
  const { form } = store.profile
  const className = clsx(css.circle, getClassName(skin))

  const onClick = useLatestCallback(() => {
    form.setSkin(skin)
  })

  return <Segment height={opt.stand ? 72 : 48} active={form.skin === skin} action={onClick}>
    <Space className={className} />
  </Segment>
})
